import { Button, Collapse, Divider, Form, Input, Empty, Switch, Popover } from "antd";
import { memo } from "react";
import { PM014ContentHandler } from "../handler/HandlerImpl";
import { useParams } from "react-router-dom";

import HomeBuilding from "../../../../../assets/icons/home-building.svg";
import MinusSvg from "../../../../../assets/icons/minus-purple.svg";
import PlusPurpose from "../../../../../assets/icons/plus-purpose.svg";
import DocumentGraySVG from "../../../../../assets/icons/document-gray.svg";
import EditBlue from "../../../../../assets/icons/edit-blue.svg";
import DeleteRed from "../../../../../assets/icons/delete-red.svg";
import IconDown from "../../../../../assets/icons/arrow.svg";
import helpers from "../../../../../common/helpers/common";
import { STATUS_APPROVE } from "../handler/Handler";
import { onBlurTrimFormItem } from "../../../../../common/helpers/typeInput";
import { isHasPrivilege } from "../../../../../common/helpers/privilege";
import {
  PRIVILEGE_CREATOR,
  PRIVILEGE_PM,
} from "../../../../../common/constants/PRIVILEGE";
import {
  AUTHORIZATION_CODE,
} from "../../../../../common/constants/AUTHORIZATION";
import { RootState } from "../../../../../store";
import { useSelector } from "react-redux";
import { PLAN_TYPE } from "../../../../../common/constants/COMMON";

const { Panel } = Collapse;

interface props {
  handler: PM014ContentHandler;
}
const MAX_LENGTH_NOTE = 300;

const SubConstructionComponent = ({ handler }: props) => {
  const { projectId } = useParams();
  const permission = useSelector(
    (state: RootState) => state.auth.authData?.permission
  );
  const isCloneProject = handler.projectInfo.parentId !== 0;
  const isRoleAdmin = useSelector(
    (state: RootState) => state.auth?.authData?.isRoleAdmin
  );
  const order = useSelector(
    (state: RootState) => state.auth?.authData?.order?.code
  );
  const isOrderBasic = order === PLAN_TYPE.PLAN_BASIC;
  const isRoleAdminSystem = useSelector(
    (state: RootState) => state.auth?.authData?.isRoleAdminSystem
  );

  return (
    <div
      className={`folder-container folder-container-active
          `}
      style={{ backgroundColor: "#ffffff" }}
    >
      <div style={{ display: "inline-block", width: "100%" }}>
        {handler.constructionUI?.other.map((element: {
          id: number;
          name: string;
          note: string;
          userId: number;
          contractValidation?: boolean;
          code: string;
          ciDocumentStatus?: {
            name: string;
            code: string;
          };
          crDocumentStatus?: {
            name: string;
            code: string;
          };
        }, index) => {
          const conditionButtonCI =
            ((permission?.includes(AUTHORIZATION_CODE.S14) &&
              permission?.includes(AUTHORIZATION_CODE.S0)) ||
              permission?.includes(AUTHORIZATION_CODE.B10) ||
              isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM]) ||
              handler.approverCIMapper[`${element?.id}`]) &&
            isOrderBasic;

          const conditionButtonCR =
            ((permission?.includes(AUTHORIZATION_CODE.S18) &&
              permission?.includes(AUTHORIZATION_CODE.S0)) ||
              permission?.includes(AUTHORIZATION_CODE.B10) ||
              isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM]) ||
              handler.approverCRMapper[`${element?.id}`]) &&
            isOrderBasic;

          const canEditContractValidation =
            (isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM]) ||
              isRoleAdmin ||
              isRoleAdminSystem) && handler.projectInfo?.status?.id !== 6;

          const notShowCollapse = !conditionButtonCR && !conditionButtonCI;

          const noteContent = (
            <div style={{ minWidth: "250px", maxWidth: "350px" }}>
              {handler.noteEdit === element?.id || element?.note === "" ? (
                <Form.Item
                  name={`addition${element.id}`}
                  className="pm005-input-note"
                >
                  <Input.TextArea
                    disabled={!(handler.noteEdit === element?.id)}
                    placeholder="メモを入力してください。"
                    autoSize
                    maxLength={MAX_LENGTH_NOTE}
                    onChange={(e: any) =>
                      handler.handleChangeInputArea(
                        e,
                        `addition${element.id}`
                      )
                    }
                    onBlur={() => {
                      onBlurTrimFormItem(
                        handler.form,
                        `addition${element.id}`
                      );
                      setTimeout(() => {
                        handler.handleCloseNoteConstruction();
                      }, 100);
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    ref={handler.refNote}
                  />
                </Form.Item>
              ) : (
                <span
                  className="pm005-note-text"
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                  }}
                >
                  {element?.note ? (
                    element?.note
                  ) : (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="データなし"
                      className="note-transform"
                    />
                  )}
                </span>
              )}
              {helpers.checkRoleUpdate(
                element?.userId,
                handler?.projectInfo?.projectManager?.id
              ) ? (
                <>
                  <Divider className="pm005-note-divider" />
                  {!(handler.noteEdit === element?.id) ? (
                    <div className="pm005-note-btn">
                      <div
                        className="pm005-note-edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();

                          handler.handleChangeNoteView(0); // ✅ đóng popover view ngay
                          handler.setNoteEdit(element?.id); // mở popover edit
                        }}
                      >
                        <img
                          src={EditBlue}
                          alt=""
                          className="pm005-note-icon-edit"
                        />
                        <span>編集</span>
                      </div>
                      {element?.note !== "" && (
                        <div
                          className="pm005-note-delete"
                          onClick={() =>
                            handler.handleDeleteNoteConstruction(
                              element?.id
                            )
                          }
                        >
                          <img
                            src={DeleteRed}
                            alt=""
                            className="pm005-note-icon-delete"
                          />
                          <span>削除</span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="pm005-note-save">
                      <span
                        className="pm005-note-save-text"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          handler.handleSaveUpdateNote(
                            element?.id,
                            `addition${element.id}`
                          );

                          handler.setNoteEdit(0);
                          handler.handleChangeNoteView(0); // ✅ đảm bảo không còn popover
                        }}
                      >
                        保存
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
          );
          const noteEditContent = (
            <div style={{ minWidth: 250, maxWidth: 350 }}>
              <Form.Item
                name={`addition${element.id}`}
                className="pm005-input-note"
              >
                <Input.TextArea
                  placeholder="メモを入力してください。"
                  autoSize
                  maxLength={MAX_LENGTH_NOTE}
                  onChange={(e: any) =>
                    handler.handleChangeInputArea(
                      e,
                      `addition${element.id}`
                    )
                  }
                  onMouseDown={(e) => e.stopPropagation()}
                  ref={handler.refNote}
                />
              </Form.Item>

              <Divider className="pm005-note-divider" />

              <div className="pm005-note-save">
                {/* ===== SAVE ===== */}
                <span
                  className="pm005-note-save-text"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    handler.handleSaveUpdateNote(
                      element?.id,
                      `addition${element.id}`
                    );

                    handler.setNoteEdit(0);
                    handler.handleChangeNoteView(0);
                  }}
                >
                  保存
                </span>

                {/* ===== CANCEL ===== */}
                <span
                  className="pm005-note-cancel-text"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    handler.handleCancelUpdateNote();
                    handler.setNoteEdit(0);
                    handler.handleChangeNoteView(0);
                  }}
                >
                  キャンセル
                </span>
              </div>
            </div>
          );
          const noteViewContent = (
            <div style={{ minWidth: 250, maxWidth: 350 }}>
              {element?.note ? (
                <span
                  className="pm005-note-text"
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {element.note}
                </span>
              ) : (
                <Form.Item
                  name={`view_addition${element.id}`}
                  className="pm005-input-note"
                >
                  <Input.TextArea
                    disabled={true}
                    placeholder="メモを入力してください。"
                    autoSize
                  />
                </Form.Item>
              )}

              {helpers.checkRoleUpdate(
                element?.userId,
                handler?.projectInfo?.projectManager?.id
              ) && (
                  <>
                    <Divider className="pm005-note-divider" />
                    <div className="pm005-note-btn">
                      {/* ===== EDIT BUTTON ===== */}
                      <div
                        className="pm005-note-edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();

                          handler.handleChangeNoteView(0); // ✅ đóng view ngay
                          handler.setNoteEdit(element?.id); // mở edit
                        }}
                      >
                        <img
                          src={EditBlue}
                          alt=""
                          className="pm005-note-icon-edit"
                        />
                        <span>編集</span>
                      </div>

                      {element?.note !== '' && (
                        <div
                          className="pm005-note-delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handler.handleDeleteNoteConstruction(
                              element?.id
                            );
                          }}
                        >
                          <img
                            src={DeleteRed}
                            alt=""
                            className="pm005-note-icon-delete"
                          />
                          <span>削除</span>
                        </div>
                      )}
                    </div>
                  </>
                )}
            </div>
          );
          return (
            <div
              key={element.id}
              style={{
                display: "flex",
                width: "calc(100% + 2px)",
                marginTop: 8,
                marginLeft: -1,
                marginRight: -1,
              }}
            >
              <Collapse
                className="folder-collapse folder-collapse-child"
                defaultActiveKey={
                  notShowCollapse ? undefined : `${element.code}${element.id}`
                }
                collapsible={notShowCollapse ? "disabled" : undefined}
                expandIcon={({ isActive }) => {
                  if (notShowCollapse) return <></>;
                  return (
                    <div
                      className={`${isActive ? "collapse-icon-active" : ""
                        } collapse-icon`}
                    >
                      <img src={IconDown} alt="" />
                    </div>
                  );
                }}
              >
                <Panel
                  collapsible={
                    !(handler.noteEdit === element?.id) ? undefined : "disabled"
                  }
                  header={
                    <div className="panel-construction-wrapper">
                      <div
                        className="tag-wrapper"
                        style={{ paddingLeft: 24 }}
                      >
                        {handler.isDisabledMinusButton(
                          handler.projectInfo,
                          element
                        ) && isOrderBasic ? (
                          <Button
                            className="button-gray-small"
                            icon={<img alt="" src={MinusSvg} />}
                            style={{ marginRight: 17.83 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handler.deleteConstruction(
                                {
                                  constructionId: element.id,
                                },
                                element?.name
                              );
                            }}
                          ></Button>
                        ) : null}
                        <img alt="" src={HomeBuilding} />
                        <span style={{ marginLeft: 12 }}>
                          {handler.projectInfo?.parentConstruction?.name || ""}
                        </span>
                        <span className="pm005-item-collapse-name">
                          {element.name}
                        </span>

                        {handler.chooseConstruction?.id !== element.id ? (
                          <></>
                        ) : (
                          <div className="tag-btn-save-wrapper">
                            <Form.Item className="tag-form-item">
                              <Button
                                className="button-purple tag-btn-save"
                                htmlType="submit"
                              >
                                保 存
                              </Button>
                            </Form.Item>
                            <Button
                              style={{
                                marginLeft: 12,
                                borderRadius: 4,
                              }}
                              onClick={handler.handleCancelUpdateConstruction}
                            >
                              キャンセル
                            </Button>
                          </div>
                        )}

                        {/* ===== POPOVER VIEW (HOVER) ===== */}
                        <Popover
                          overlayClassName="pm005-note-popover"
                          content={noteViewContent}
                          trigger="hover"
                          visible={
                            handler.noteEdit === 0 &&
                            handler.noteView === element?.id &&
                            element?.id !== 0
                          }
                          onVisibleChange={(visible) => {
                            if (handler.noteEdit !== 0) return;

                            if (visible) {
                              handler.handleChangeNoteView(element?.id);
                            } else {
                              handler.handleChangeNoteView(0);
                            }
                          }}
                          placement="rightTop"
                          getPopupContainer={(trigger) =>
                            trigger.parentNode as HTMLElement
                          }
                        >
                          <div
                            className="pm005-note"
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <img src={DocumentGraySVG} alt="" />
                          </div>
                        </Popover>

                        <Popover
                          overlayClassName="pm005-note-popover-edit"
                          content={noteEditContent}
                          trigger="click"
                          visible={handler.noteEdit === element?.id}
                          placement="rightTop"
                          getPopupContainer={(trigger) =>
                            trigger.parentNode as HTMLElement
                          }
                          onVisibleChange={(visible) => {
                            // 👉 click ra ngoài hoặc ESC
                            if (!visible) {
                              handler.setNoteEdit(0);
                              handler.handleChangeNoteView(0);
                            }
                          }}
                        >
                          <span />
                        </Popover>
                      </div>
                      {isOrderBasic && (
                        <div className="pm005-contract-validation-wrapper">
                          <span>工事契約状況</span>
                          <div
                            className="pm005-contract-validation-wrapper-switch-wrapper"
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.stopPropagation()}
                            style={{
                              backgroundColor:
                                (element?.contractValidation ?? false)
                                  ? "#0FA44A26"
                                  : "#FF383C26",
                            }}
                          >
                            <span
                              style={{
                                color: (element?.contractValidation ?? false)
                                  ? "#0FA44A"
                                  : "#FF383C",
                              }}
                            >
                              {(element?.contractValidation ?? false)
                                ? "契約済み"
                                : "未契約"}
                            </span>
                            <Switch
                              className="pm005-contract-validation-switch"
                              checked={
                                element?.contractValidation ?? false
                              }
                              disabled={!canEditContractValidation}
                              onChange={(checked) => {
                                handler.updateContractValidation({
                                  constructionId: element.id,
                                  contractValidation: checked,
                                });
                              }}
                            />

                          </div>
                        </div>
                      )}
                    </div>
                  }
                  key={`${element.code}${element.id}`}
                >
                  <div className="tag-contaner-folder">
                    {conditionButtonCI ? (
                      <div
                        className="tag-white-container pm005-btn-view"
                        onClick={() =>
                          handler.onViewConstructionInquiry(
                            element.id,
                            projectId || ""
                          )
                        }
                      >
                        <span>工事引合書</span>
                        <div
                          className="pm005-status-approve"
                          style={{
                            color:
                              STATUS_APPROVE[
                                element.ciDocumentStatus?.code || "reject"
                              ].color,
                            backgroundColor:
                              STATUS_APPROVE[
                                element.ciDocumentStatus?.code || "reject"
                              ].background_color,
                          }}
                        >
                          {element.ciDocumentStatus?.name}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    {conditionButtonCR ? (
                      <div
                        className="tag-white-container pm005-btn-view"
                        onClick={() =>
                          handler.onViewRunningBudget(
                            element.id,
                            projectId || ""
                          )
                        }
                      >
                        <span>実行予算書</span>
                        <div
                          className="pm005-status-approve"
                          style={{
                            color:
                              STATUS_APPROVE[
                                element.crDocumentStatus?.code || "reject"
                              ].color,
                            backgroundColor:
                              STATUS_APPROVE[
                                element.crDocumentStatus?.code || "reject"
                              ].background_color,
                          }}
                        >
                          {element.crDocumentStatus?.name}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </Panel>
              </Collapse>
            </div>
          );
        })}
        {/* không là dự án clone VÀ là (PM hoặc người tạo hoặc admin) */}
        {
          !isCloneProject && isOrderBasic && (isHasPrivilege(handler.projectInfo, [PRIVILEGE_PM, PRIVILEGE_CREATOR])
            || isRoleAdmin) ? (
            <div
              style={{
                display: "inline-flex",
                columnGap: "12px",
                alignItems: "center",
                marginLeft: "40px",
                cursor: "pointer",
                paddingTop: 22,
                paddingBottom: 22,
              }}
              onClick={(e) => {
                if (e.detail === 1) {
                  projectId &&
                    handler.postAddConstruction({
                      projectId: Number(projectId),
                    });
                }
              }}
            >
              <div className="button-gray-small">
                <img alt="" src={PlusPurpose} />
              </div>
              <div className="add-construction">
                <span>工事追加</span>
              </div>
            </div>
          ) : null}
      </div>
    </div>
  );
};

export default memo(SubConstructionComponent);